import PropTypes from "prop-types";

import { MONTH_DATE_YEAR_FORMAT, format, unixToDateTime } from "utils/date";
import { numberSeparator, roundOff } from "utils";

const getValueText = (p) => {
  const value = p.value;
  const percentage = p.payload?.perValue
    ? roundOff(value)
    : roundOff(value * 100);
  const beforeDecimalVal = String(value).split(".")[0];
  const { dollarValue, plainValue, tooltipValueText } = p.payload;

  if (tooltipValueText) {
    return <span>{tooltipValueText}</span>;
  }

  if (dollarValue) {
    return <span>${numberSeparator(value)}</span>;
  }

  // Check if a number has a decimal place
  if (!plainValue && value % 1 != 0 && beforeDecimalVal.length < 4) {
    return <span>{numberSeparator(percentage)}%</span>;
  }

  return <span>{numberSeparator(value)}</span>;
};

const getLabelText = (p, i) => {
  if (p?.payload?.label2 && i == 1) {
    return p.payload.label2;
  } else if (p?.payload?.label) {
    return p.payload.label;
  } else if (p?.name === "value") {
    return "";
  }

  return p.name;
};

export const ChartTooltip = ({ active = false, payload = [] }) => {
  if (active && payload && payload.length) {
    return (
      <div className="chart-tooltip">
        {!payload[0].payload.hideTimestamp && (
          <span className="datetime">
            {unixToDateTime(payload[0].payload.name) ||
              (payload[0].payload.name &&
              !isNaN(new Date(payload[0].payload.name))
                ? format(
                    MONTH_DATE_YEAR_FORMAT,
                    new Date(payload[0].payload.name)
                  )
                : payload[0].payload.name)}
          </span>
        )}

        {payload.map((p, i) => {
          return (
            <div key={i} className="label" style={{ color: p.color }}>
              <span>{getLabelText(p, i)} </span>
              <span>{getValueText(p)}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

ChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

ChartTooltip.displayName = "ChartTooltip";
